module.exports = __webpack_public_path__ + "img/axa-logo.4e2e86b0.svg";